export default "__VITE_ASSET__229e96ff__"